<template>
  <router-link
    :exact="!matchChildrenRoutes"
    tag="li"
    class="LandscapeNavLink"
    :class="{'has-menu': hasMenu}"
    :to="{
      name: to,
      params: {
        actor: selectedActor && selectedActor.pathArr,
        landscapeSlug: $route.params.landscapeSlug
      }
    }"
  >
    <a>
      <slot></slot>
    </a>
  </router-link>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'LandscapeNavLink',
  props: {
    to: {
      type: String,
      required: true
    },
    matchChildrenRoutes: {
      type: Boolean,
      default: false
    },
    hasMenu: {
      type: Boolean,
      default: false
    }
  },
  computed: mapGetters(['selectedActor'])
}
</script>

<style scoped>
.LandscapeNavLink {
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 14px;
  text-transform: uppercase;
  font-family: theme('fontFamily.mono');
  a {
    line-height: 1;
    color: theme('colors.gray.500');
    &:hover {
      text-decoration: none;
    }
  }
  &.router-link-active {
    border-bottom: 4px solid white;
    a {
      margin-top: 4px;
    }
    &.has-menu {
      border-bottom-color: theme('colors.gray.100');
    }
  }
  &.router-link-active,
  &.router-link-active a,
  a:hover {
    color: white;
  }
}
</style>
